export default __webpack_public_path__ + "static/media/b6.457b0e9e.jpg";